import React from 'react';

import Link from '../components/Link';
import {StyledCheckbox} from '../components/Forms';

// Opt-in for contributing session recordings to AI research
const RecordingConsentCheckbox = ({
  checked, onChange, disabled = false, className = 'text-xs text-gray-500 mb-4',
}) => (
  <label className={`flex items-start gap-2 cursor-pointer ${className}`}>
    <StyledCheckbox
      name="recording_consent"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      disabled={disabled}
      className="my-0 shrink-0"
    />
    <span>
      (Optional) Contribute an anonymized recording for research
      {' ('}
      <Link href="/recording-release" target="_blank" className="underline">see terms</Link>
      ).
    </span>
  </label>
);

export default RecordingConsentCheckbox;
